import { FormControl } from '@angular/forms';
import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { filter, tap } from 'rxjs';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { EditableComponent } from '@dpr-details/models/component';
import { Constants } from '@shared/utils';

@UntilDestroy()
@Component({
  selector: 'app-dpr-comment',
  templateUrl: './dpr-comment.component.html',
  styleUrls: ['./dpr-comment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DprCommentComponent implements EditableComponent, OnChanges {
  @Input({ required: true }) comment: string;
  @Input({ required: true }) canEdit: boolean;
  @Input() maxLength: number = Constants.FieldLimits.maxCommentLength;

  @Output() commentChanged = new EventEmitter();

  editCommentLabel = $localize`:@@dprDetails.dprComment.lblEditComment:Edit Comment`;
  commentLabel = $localize`:@@dprDetails.dprComment.lblComment:Comment`;

  commentFormControl = new FormControl<string | null>(null);

  constructor() {
    this.commentFormControl.valueChanges
      .pipe(
        untilDestroyed(this),
        filter((value) => value !== this.comment),
        tap(() => {
          this.commentChanged.emit();
        })
      )
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.comment) {
      this.commentFormControl.setValue(this.comment);
    }

    if (changes.canEdit) {
      if (changes.canEdit.currentValue) {
        this.commentFormControl.enable({ onlySelf: true });
      } else {
        this.commentFormControl.disable({ onlySelf: true });
      }
    }
  }
}
